//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = '/prototype/accounting/charge-codes';

export default {

    props: ['global', 'category', 'parent'],
    data: function data() {
        return {
            categories: [],
            accounts: [],
            selectedCategory: 'Loading...',
            selectedCategoryID: 0,
            showMenu: false,
            loading: true,
            headers: ["GL Code", "Description", "Amount", "GL Write Off Code", "Effective Start", "Effective End", "Recurring", "Active/InActive"],
            items: [],
            updateItem: {},
            noresults: true,
            addNewCategory: false,
            newCategoryVal: '',
            confirmDelete: false,
            chargeCodeValidations: [{ model: 'updateItem.gl_account', rules: 'required' }, { model: 'updateItem.amount', rules: 'required | integer | min:0' }]
        };
    },

    methods: {
        edit: function edit(item, idx) {
            this.updateItem = item;
            this.updateItem.idx = idx;
            if (item.gl_account) {
                this.updateItem.gl_account.label = item.gl_account.number + '  - ' + item.gl_account.name;
            }
            if (item.gl_write_off_account) {
                this.updateItem.gl_write_off_account.label = item.gl_account.number + '  - ' + item.gl_account.name;
            }
            this.updateItem.effective_start = moment(item.effective_start).format("MM/DD/YYYY");
            this.updateItem.effective_end = moment(item.effective_end).format("MM/DD/YYYY");
        },
        toggle: function toggle() {
            this.showMenu = !this.showMenu;
        },
        changeCategory: function changeCategory(category) {
            var _this = this;

            this.loading = true;
            this.selectedCategoryID = category.id;
            this.selectedCategory = category.name;
            this.showMenu = false;
            axios.post(BASE_URL + '/codes', { id: category.id }).then(function (response) {
                return _this.items = response.data;
            });
            this.loading = false;
        },
        add: function add() {
            this.items.unshift({
                id: null,
                accounting_charge_code_category_id: this.selectedCategoryID,
                gl_account: null,
                name: '',
                amount: 0.00,
                gl_write_off_account: null,
                show_resident: true,
                notify_resident: true,
                recurring: false,
                is_active: true
            });
            this.edit(this.items[0], 0);
        },
        save: function save() {
            var _this2 = this;

            this.validator.setRules(this.chargeCodeValidations).validate();

            if (this.validator.fails()) {
                return;
            }
            var item = this.updateItem;
            item.global = this.$props.global;
            axios.post(BASE_URL + '/store', item).then(function (response) {
                _this2.updateItem = {};
                Event.$emit('refresh-accounting-ar-settings');
                _this2.$snotify.success('The code was saved.');
            });
        },
        remove: function remove(id, idx) {
            var _this3 = this;

            if (Object.keys(this.updateItem).length > 0) {
                this.updateItem = {};
            } else {

                axios.post(BASE_URL + '/destroy', { id: id }).then(function (response) {
                    if (response.data.error) {
                        _this3.$snotify.error('Error deleting charge code: ' + response.data.error);
                    } else {
                        _this3.items.splice(idx, 1);
                        _this3.updateItem = {};
                        _this3.$snotify.success('The code was removed.');
                    }
                });
            }
        },
        processDelete: function processDelete() {
            var _this4 = this;

            axios.post(BASE_URL + '/category/destroy', { id: this.selectedCategoryID }).then(function (response) {
                _this4.load();
                _this4.$snotify.danger('The category was removed.');
            });
        },
        load: function load() {
            var _this5 = this;

            //Object.assign(this.$data, this.$options.data())
            this.loading = true;

            // get charge code categories
            axios.post(BASE_URL + '/categories', { parent: this.parent }).then(function (response) {
                _this5.noresults = false;
                _this5.categories = response.data;
                if (_this5.categories.length > 0) {
                    // set category from prop
                    if (_this5.$props.category) {
                        var categoryName = _this5.$props.category;
                        var matchedCategory = false;
                        _this5.categories.forEach(function (cat) {
                            if (cat.name == categoryName) {
                                matchedCategory = cat;
                            }
                        });
                        if (matchedCategory) {
                            _this5.changeCategory(matchedCategory);
                        }
                    } else {
                        matchedCategory = _this5.categories[0];
                    }
                    _this5.selectedCategory = matchedCategory.name;
                    _this5.selectedCategoryID = matchedCategory.id;
                    axios.post(BASE_URL + '/codes', { id: matchedCategory.id }).then(function (response) {
                        return _this5.items = response.data;
                    });
                } else {
                    _this5.showMenu = true;
                    _this5.noresults = true;
                    _this5.selectedCategory = '';
                }
            }).then(function () {

                // get gl accounts
                axios.post('/prototype/accounting/general-ledger/accounts/fetch').then(function (response) {
                    _this5.accounts = response.data;
                    _this5.loading = false;
                });
            });
        },
        saveNewCategory: function saveNewCategory() {
            var _this6 = this;

            axios.post(BASE_URL + '/categories/store', { parent: this.parent, name: this.newCategoryVal }).then(function (response) {
                _this6.addNewCategory = false;
                _this6.newCategoryVal = '';
                _this6.categories.push(response.data);
                _this6.selectedCategory = response.data.name;
                _this6.selectedCategoryID = response.data.id;
                _this6.items = [];
                _this6.showMenu = false;
            });
        }
    },

    mounted: function mounted() {
        var _this7 = this;

        this.load();
        this.$initValidator();
        Event.$on('refresh-accounting-ar-settings', function () {
            return _this7.load();
        });
    },


    computed: {
        canPostTo: function canPostTo() {
            return this.accounts.filter(function (account) {
                return account.can_post_to === 1;
            });
        },
        accountNames: function accountNames() {
            return this.canPostTo.map(function (account) {
                return { id: account.id, label: account.number + ' - ' + account.name };
            });
        },

        isSuperAdmin: function isSuperAdmin() {
            return window.user.role === 'super-admin';
        }

    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/settings/accounting/ChargeCodeSettings.vue
// module id = jKLo
// module chunks = 0 1